// extracted by mini-css-extract-plugin
export default {"wrap":"eA-z","fullWidth":"fA-z","searchPlacement":"gA-z","items":"hA-z","featureCss":"iA-z","disabled":"jA-z","imgCss":"kA-z"};